import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Who,
  Benefits,
  Metrics,
  Values,
  Pricing,
  AreYouReady,
} from './components';

const DEMO_VIDEO_EMBED_URL = 'https://www.youtube.com/embed/DNYNvZsZMLM';

const LandingMediaKitHablemosDeTodo = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Container>
        <Who themeMode={themeMode} />
      </Container>
      <Container>
        <Box
          sx={{
            position: 'relative',
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden',
            borderRadius: isSm ? 4 : 0,
            boxShadow: 3,
          }}
        >
          <Box
            component="iframe"
            src={DEMO_VIDEO_EMBED_URL}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            title="Hablemos de Todo | Anuncia con nosotros"
          />
        </Box>
      </Container>
      <Container>
        <Benefits />
      </Container>
      <Container>
        <Metrics />
      </Container>
      <Container>
        <Values />
      </Container>
      <Container>
        <Pricing />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitHablemosDeTodo.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default LandingMediaKitHablemosDeTodo;
